import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { useEffect, useState } from 'react';
import styled from '@xstyled/styled-components';
import { InputNumber, notification } from 'antd';
import { styleVariables } from '@lib/common';
import { SubmissionScore } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledInputNumberContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  border: ", ";\n  padding: ", ";\n  background-color: ", ";\n"])), styleVariables.borderRadius.medium, function (props) {
  return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderDefault);
}, styleVariables.padding.medium, function (props) {
  var disabled = props.disabled;

  if (disabled) {
    return props.theme.color.backgroundOverlay;
  }

  return props.theme.color.bgDefault;
});
var StyledInputNumber = styled(InputNumber)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  .ant-input-number {\n    width: 40px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    font-size: ", ";\n    font-weight: ", ";\n    color: ", ";\n    padding: 0;\n    background-color: ", ";\n  }\n\n  .ant-input-number-input {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .ant-input-number-group-addon {\n    min-width: 55px;\n    background-color: ", ";\n    border-color: transparent;\n    font-weight: ", ";\n    font-size: ", ";\n    padding: 0;\n    margin-left: ", " !important;\n  }\n"])), styleVariables.font.fontSizeSupport, styleVariables.font.fontWeightNormal, function (props) {
  return props.theme.color.textSupport;
}, function (props) {
  var disabled = props.disabled;

  if (disabled) {
    return props.theme.color.backgroundOverlay;
  }

  return props.theme.color.bgDefault;
}, function (props) {
  var disabled = props.disabled;

  if (disabled) {
    return props.theme.color.backgroundOverlay;
  }

  return props.theme.color.bgDefault;
}, styleVariables.font.fontWeightNormal, styleVariables.font.fontSizeSupport, styleVariables.margin.medium);
var StyledOnGradingText = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-style: italic;\n  color: #666;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 4px 8px;\n  text-align: center;\n"])));
export var ScoreInputNumber = function ScoreInputNumber(_ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      max = _ref.max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      score = _ref.score,
      onGradedScore = _ref.onGradedScore;

  var _useState = useState(score),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    setValue(score);
  }, [score]);

  var handleOnPressEnter = function handleOnPressEnter(e) {
    e.stopPropagation();
    e.target.blur();
  };

  var handleOnBlur = function handleOnBlur(e) {
    var inputValue = Number(e.target.value);
    var isInvalidScore = inputValue < min || max < inputValue || !e.target.value || isNaN(inputValue) || inputValue === score;

    if (isInvalidScore) {
      // Show error toast when score exceeds maximum
      if (max < inputValue) {
        notification.error({
          message: 'Invalid Score',
          description: "Score cannot exceed the maximum of ".concat(max, " points."),
          duration: 3
        });
      }

      setValue(score);
      return;
    }

    setValue(inputValue);
    onGradedScore(inputValue);
  };

  var isScored = value !== undefined && value !== null && value !== SubmissionScore["default"].value;
  var isOnGrading = value === SubmissionScore["default"].value; // Show italic text when on grading

  if (isOnGrading) {
    return /*#__PURE__*/_jsx(StyledOnGradingText, {
      children: /*#__PURE__*/_jsx("i", {
        children: "on Grading..."
      })
    });
  }

  return /*#__PURE__*/_jsx(StyledInputNumberContainer, {
    disabled: disabled,
    children: /*#__PURE__*/_jsx(StyledInputNumber, {
      size: "small",
      bordered: false,
      controls: false,
      addonAfter: "/".concat(max, " ").concat(label.score),
      disabled: disabled,
      min: min,
      max: max,
      value: isScored ? value : undefined,
      onPressEnter: handleOnPressEnter,
      onBlur: handleOnBlur,
      placeholder: isScored ? undefined : '-'
    })
  });
};